/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_PromptInputs */



/**
* | output |
* | --- |
* | "Would you like to enable external device control (such as foot pedal)?" |
*
* @param {Creator_Ext_Device_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_prompt = /** @type {((inputs?: Creator_Ext_Device_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Souhaitez-vous activer le controle d'un appareil externe (comme une pedale) ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Möchten Sie die Steuerung durch externe Geräte (z. B. ein Fußpedal) aktivieren?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Desideri abilitare il controllo di un dispositivo esterno (ad esempio un pedale)?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Хотите включить управление внешними устройствами (например, ножной педалью)?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Quieres habilitar el control de dispositivos externos (como el pedal)?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您是否希望启用外部设备控制（例如脚踏板）？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("外部デバイスコントロール（フットペダルなど）を有効にしますか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप बाहरी उपकरण नियंत्रण (जैसे कि फुट पेडल) को सक्षम करना चाहेंगे?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deseja ativar o controle por dispositivo externo (como um pedal)?")
	return /** @type {LocalizedString} */ ("Would you like to enable external device control (such as foot pedal)?")
});